import React,{useEffect, useState} from 'react';
import styled from 'styled-components';
import { Link, useNavigate ,NavLink} from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Sidebar } from 'primereact/sidebar';
import golden_box from "../../assets/images/golden_box.gif"
//mui
import Drawer from '@mui/material/Drawer';
import Modal from '@mui/material/Modal';
import { Button, Grid,Box, IconButton } from '@mui/material';
import Close from '@mui/icons-material/Close';
import CloseIcon from '@mui/icons-material/Close';
//api requests
import { Helper } from "../../tools/helper";
import apiRoutes from "../../apiRoutes";
//redux
import { connect } from 'react-redux'

import { useBreakpoint } from 'react-use-size';
import { nav_with_user_login, nav_without_user_login } from '../../data/data_subNavbar';
// custom styles
import {ListSection ,ListSectionCollapse,Icon,ButtonSection,DivDrower,Title,LinkPages,ItemListSectionBase,ItemListSection} from "../../styles/subNavbarStyles"



export  const Item_list = ({isScroll,lang, isSmall}) =>{
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [isDrower,setIsDrower] = useState(false)
  

    const data_list =  localStorage.hasOwnProperty("user")?nav_with_user_login:nav_without_user_login
    return <>
            <ItemListSectionBase 
            className={isScroll?"scroll meun-cat":"meun-cat"}
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={()=>setIsDrower(true)} >
                <Icon>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill={isScroll?"black":"white"} d="M2 6C2 5.73478 2.10536 5.48043 2.29289 5.29289C2.48043 5.10536 2.73478 5 3 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6C22 6.26522 21.8946 6.51957 21.7071 6.70711C21.5196 6.89464 21.2652 7 21 7H3C2.73478 7 2.48043 6.89464 2.29289 6.70711C2.10536 6.51957 2 6.26522 2 6ZM2 12.032C2 11.7668 2.10536 11.5124 2.29289 11.3249C2.48043 11.1374 2.73478 11.032 3 11.032H21C21.2652 11.032 21.5196 11.1374 21.7071 11.3249C21.8946 11.5124 22 11.7668 22 12.032C22 12.2972 21.8946 12.5516 21.7071 12.7391C21.5196 12.9266 21.2652 13.032 21 13.032H3C2.73478 13.032 2.48043 12.9266 2.29289 12.7391C2.10536 12.5516 2 12.2972 2 12.032ZM3 17.065C2.73478 17.065 2.48043 17.1704 2.29289 17.3579C2.10536 17.5454 2 17.7998 2 18.065C2 18.3302 2.10536 18.5846 2.29289 18.7721C2.48043 18.9596 2.73478 19.065 3 19.065H21C21.2652 19.065 21.5196 18.9596 21.7071 18.7721C21.8946 18.5846 22 18.3302 22 18.065C22 17.7998 21.8946 17.5454 21.7071 17.3579C21.5196 17.1704 21.2652 17.065 21 17.065H3Z"/>
                    </svg> 
                </Icon>
            </ItemListSectionBase >
            <Drawer
            anchor={"left"}
            open={isDrower}
            onClose={()=>{setIsDrower(false)}}
          >
            <DivDrower >
                <Title style={{textAlign:"center",padding:"20px 0"}} >
                <svg xmlns="http://www.w3.org/2000/svg" width="131" height="60" viewBox="0 0 131 60" fill="none">
                    <path d="M42.7759 15.0384L36.3983 16.7473C36.4532 16.6683 36.5103 16.5906 36.5623 16.5085C36.983 15.87 37.2675 15.1516 37.3979 14.3981C37.5282 13.6447 37.5017 12.8725 37.3201 12.1298C37.1275 11.3156 36.7706 10.5494 36.2711 9.87812C35.7717 9.20687 35.1404 8.64478 34.4159 8.22636C33.6914 7.80793 32.8891 7.54199 32.0581 7.44487C31.2271 7.34775 30.385 7.4215 29.5836 7.66158C28.8491 7.87543 28.1668 8.23858 27.5791 8.7283C26.9915 9.21801 26.5113 9.82376 26.1686 10.5076C25.7004 11.4766 25.3863 12.5127 25.2377 13.5785C24.5761 12.7297 23.7861 11.9895 22.8962 11.3844C22.2574 10.9636 21.5387 10.6791 20.7849 10.5488C20.0312 10.4185 19.2586 10.4452 18.5157 10.6272C17.7015 10.82 16.9354 11.1772 16.2643 11.6768C15.5932 12.1764 15.0313 12.8079 14.6131 13.5325C14.1949 14.2571 13.9292 15.0596 13.8323 15.8906C13.7355 16.7216 13.8095 17.5636 14.0498 18.365C14.2638 19.0991 14.627 19.7811 15.1166 20.3684C15.6062 20.9557 16.2117 21.4356 16.8953 21.7782C16.9805 21.8197 17.0688 21.8584 17.1567 21.903L10.7792 23.6119C10.0078 23.8186 9.35003 24.3233 8.95069 25.015C8.55136 25.7066 8.44314 26.5286 8.64985 27.3001L10.2087 33.1176C10.4154 33.8891 10.9201 34.5468 11.6118 34.9462C12.3034 35.3455 13.1254 35.4537 13.8969 35.247L17.0145 46.8822C17.2212 47.6536 17.7259 48.3114 18.4176 48.7107C19.1092 49.11 19.9312 49.2182 20.7027 49.0115L46.8817 41.9969C47.6532 41.7902 48.3109 41.2855 48.7103 40.5938C49.1096 39.9021 49.2178 39.0801 49.0111 38.3087L45.8935 26.6736C46.6649 26.4668 47.3227 25.9621 47.722 25.2705C48.1214 24.5788 48.2296 23.7568 48.0229 22.9854L46.464 17.1678C46.2573 16.3963 45.7526 15.7386 45.061 15.3393C44.3693 14.9399 43.5473 14.8317 42.7759 15.0384ZM28.8665 11.8501C29.0286 11.5341 29.2544 11.2551 29.5295 11.0304C29.8046 10.8058 30.1232 10.6405 30.4653 10.5449L30.5544 10.521C30.9571 10.4158 31.3768 10.392 31.7889 10.4511C32.201 10.5102 32.5971 10.6509 32.9541 10.865C33.3111 11.0791 33.6217 11.3623 33.8678 11.698C34.114 12.0338 34.2906 12.4152 34.3874 12.8201C34.4756 13.1641 34.4918 13.5227 34.4348 13.8733C34.3778 14.2239 34.249 14.5589 34.0564 14.8573C32.7403 16.8467 30.0212 18.152 28.2975 18.8166C27.9998 16.8328 27.85 13.8742 28.8665 11.8501ZM17.2325 15.0376C17.6451 14.3232 18.3229 13.8005 19.1187 13.5833L19.2078 13.5594C19.5518 13.4712 19.9104 13.455 20.261 13.512C20.6116 13.5689 20.9466 13.6978 21.245 13.8904C23.2321 15.2051 24.536 17.9188 25.1985 19.6352C23.3827 19.9269 20.3787 20.1473 18.2466 19.0838C17.9306 18.9216 17.6515 18.6959 17.4269 18.4208C17.2023 18.1457 17.037 17.8271 16.9413 17.485C16.8206 17.0794 16.7835 16.6535 16.8323 16.2331C16.8811 15.8128 17.0148 15.4067 17.2253 15.0395L17.2325 15.0376ZM11.5586 26.5207L26.1026 22.6236L27.6614 28.4412L13.1175 32.3382L11.5586 26.5207ZM16.8056 34.4676L28.4408 31.35L31.5584 42.9851L19.9233 46.1028L16.8056 34.4676ZM46.1023 39.0881L34.4672 42.2057L31.3496 30.5706L42.9847 27.453L46.1023 39.0881ZM45.1141 23.7648L30.5702 27.6618L29.0113 21.8442L43.5553 17.9472L45.1141 23.7648Z" fill="#D80621"/>
                    <path d="M41.2068 11.2653L42.3358 10.889C46.2229 9.5933 50.406 11.7997 51.5316 15.7394V15.7394" stroke="#D80621" strokeWidth="0.688319"/>
                    <path d="M39.8304 9.07589L41.4277 8.54345C46.9272 6.71027 52.8454 9.83187 54.438 15.4059V15.4059" stroke="#D80621" strokeWidth="0.688319"/>
                    <path d="M66.0249 35.2017H66.7091L64.4348 41.9473H63.6832L61.7077 36.1943L59.7226 41.9473H58.9806L56.7064 35.2017H57.4388L59.3853 41.0029L61.3994 35.2017H62.0643L64.0494 41.0318L66.0249 35.2017ZM68.1907 35.7703C67.9112 35.7703 67.6896 35.5487 67.6896 35.2788C67.6896 35.0186 67.9112 34.797 68.1907 34.797C68.4701 34.797 68.6918 35.009 68.6918 35.2692C68.6918 35.5487 68.4798 35.7703 68.1907 35.7703ZM67.8437 41.9473V36.8785H68.5279V41.9473H67.8437ZM73.0142 36.8399C74.2477 36.8399 75.0957 37.553 75.0957 39.0081V41.9473H74.4115V39.0756C74.4115 38.006 73.8526 37.4567 72.889 37.4567C71.8 37.4567 71.1159 38.1312 71.1159 39.2876V41.9473H70.4317V36.8785H71.0869V37.8132C71.4531 37.1965 72.1373 36.8399 73.0142 36.8399ZM83.8984 39.4129C83.8984 39.4707 83.8888 39.5478 83.8888 39.6249H79.6487C79.7258 40.6849 80.5353 41.3884 81.6435 41.3884C82.2602 41.3884 82.8095 41.1667 83.1949 40.7234L83.5804 41.1667C83.1275 41.7064 82.424 41.9954 81.6242 41.9954C80.0438 41.9954 78.9645 40.9162 78.9645 39.4129C78.9645 37.9096 80.0149 36.8399 81.4411 36.8399C82.8673 36.8399 83.8984 37.8903 83.8984 39.4129ZM81.4411 37.4278C80.4582 37.4278 79.7354 38.1216 79.6487 39.1141H83.2431C83.1564 38.1216 82.4337 37.4278 81.4411 37.4278ZM88.7817 36.8785H89.4562L87.2013 41.9473H86.4978L84.2525 36.8785H84.9656L86.864 41.1956L88.7817 36.8785ZM94.7018 39.4129C94.7018 39.4707 94.6921 39.5478 94.6921 39.6249H90.4521C90.5292 40.6849 91.3387 41.3884 92.4468 41.3884C93.0636 41.3884 93.6129 41.1667 93.9983 40.7234L94.3838 41.1667C93.9309 41.7064 93.2274 41.9954 92.4276 41.9954C90.8472 41.9954 89.7679 40.9162 89.7679 39.4129C89.7679 37.9096 90.8183 36.8399 92.2445 36.8399C93.6707 36.8399 94.7018 37.8903 94.7018 39.4129ZM92.2445 37.4278C91.2616 37.4278 90.5388 38.1216 90.4521 39.1141H94.0465C93.9598 38.1216 93.237 37.4278 92.2445 37.4278ZM96.7497 37.871C97.0677 37.1965 97.7133 36.8399 98.6481 36.8399V37.5049C98.5902 37.5049 98.5324 37.4952 98.4842 37.4952C97.4242 37.4952 96.7786 38.1698 96.7786 39.3647V41.9473H96.0944V36.8785H96.7497V37.871ZM103.688 36.8785H104.363L101.828 42.5544C101.404 43.5469 100.865 43.8649 100.142 43.8649C99.6697 43.8649 99.2168 43.7107 98.9084 43.4024L99.2264 42.8916C99.4769 43.1422 99.7853 43.2771 100.151 43.2771C100.604 43.2771 100.913 43.0651 101.202 42.4291L101.424 41.9376L99.1589 36.8785H99.872L101.78 41.186L103.688 36.8785ZM110.277 41.1474L110.518 41.6389C110.248 41.8798 109.843 41.9954 109.448 41.9954C108.494 41.9954 107.964 41.4558 107.964 40.5211V37.4567H107.058V36.8785H107.964V35.7703H108.648V36.8785H110.19V37.4567H108.648V40.4825C108.648 41.08 108.956 41.4076 109.525 41.4076C109.804 41.4076 110.084 41.3209 110.277 41.1474ZM112.11 35.7703C111.831 35.7703 111.609 35.5487 111.609 35.2788C111.609 35.0186 111.831 34.797 112.11 34.797C112.389 34.797 112.611 35.009 112.611 35.2692C112.611 35.5487 112.399 35.7703 112.11 35.7703ZM111.763 41.9473V36.8785H112.447V41.9473H111.763ZM120.672 36.8399C121.906 36.8399 122.715 37.553 122.715 39.0081V41.9473H122.031V39.0756C122.031 38.006 121.492 37.4567 120.576 37.4567C119.535 37.4567 118.88 38.1312 118.88 39.2876V41.9473H118.196V39.0756C118.196 38.006 117.656 37.4567 116.731 37.4567C115.7 37.4567 115.035 38.1312 115.035 39.2876V41.9473H114.351V36.8785H115.006V37.8036C115.363 37.1965 116.018 36.8399 116.866 36.8399C117.704 36.8399 118.36 37.1965 118.668 37.9096C119.034 37.2543 119.757 36.8399 120.672 36.8399ZM129.013 39.4129C129.013 39.4707 129.003 39.5478 129.003 39.6249H124.763C124.84 40.6849 125.65 41.3884 126.758 41.3884C127.375 41.3884 127.924 41.1667 128.309 40.7234L128.695 41.1667C128.242 41.7064 127.538 41.9954 126.739 41.9954C125.158 41.9954 124.079 40.9162 124.079 39.4129C124.079 37.9096 125.129 36.8399 126.556 36.8399C127.982 36.8399 129.013 37.8903 129.013 39.4129ZM126.556 37.4278C125.573 37.4278 124.85 38.1216 124.763 39.1141H128.358C128.271 38.1216 127.548 37.4278 126.556 37.4278Z" fill="#606060"/>
                    <path d="M60.6587 27.463C59.1307 27.463 57.5888 27.0088 56.7353 26.348L57.4925 24.6685C58.3047 25.2604 59.5161 25.6734 60.6725 25.6734C61.9941 25.6734 62.531 25.2329 62.531 24.6409C62.531 22.8375 56.928 24.0765 56.928 20.4973C56.928 18.8591 58.2496 17.4962 60.9891 17.4962C62.2006 17.4962 63.4395 17.7853 64.3344 18.3497L63.646 20.043C62.7512 19.5336 61.8289 19.2858 60.9754 19.2858C59.6538 19.2858 59.1444 19.7814 59.1444 20.3871C59.1444 22.163 64.7473 20.9378 64.7473 24.4757C64.7473 26.0864 63.412 27.463 60.6587 27.463ZM70.6214 19.7814C72.3697 19.7814 73.6913 20.8001 73.6913 23.0578V27.2979H71.5437V23.3882C71.5437 22.1905 70.9931 21.6399 70.0432 21.6399C69.0107 21.6399 68.2673 22.2731 68.2673 23.636V27.2979H66.1198V17.0832H68.2673V20.6625C68.8455 20.0843 69.6715 19.7814 70.6214 19.7814ZM78.6252 19.7814C80.8829 19.7814 82.1907 20.8277 82.1907 23.0716V27.2979H80.1809V26.3755C79.7816 27.0501 79.0107 27.408 77.9232 27.408C76.1886 27.408 75.1561 26.4443 75.1561 25.1641C75.1561 23.8563 76.0785 22.9477 78.3362 22.9477H80.0432C80.0432 22.0253 79.4925 21.4884 78.3362 21.4884C77.5515 21.4884 76.7393 21.75 76.2024 22.1768L75.4315 20.6762C76.2437 20.098 77.4413 19.7814 78.6252 19.7814ZM78.4601 25.9625C79.1759 25.9625 79.7954 25.6321 80.0432 24.9576V24.2004H78.5702C77.5652 24.2004 77.2486 24.5721 77.2486 25.0677C77.2486 25.6046 77.7029 25.9625 78.4601 25.9625ZM89.6547 27.2979L87.3144 24.3931L86.2819 25.4119V27.2979H84.1344V17.0832H86.2819V22.8651L89.4207 19.8915H91.9812L88.8975 23.0303L92.2565 27.2979H89.6547ZM100.155 23.6222C100.155 23.7874 100.127 24.0215 100.113 24.2004H94.5104C94.7169 25.1228 95.5015 25.6872 96.6304 25.6872C97.4151 25.6872 97.9795 25.4532 98.4888 24.9713L99.6315 26.2103C98.9431 26.995 97.9107 27.408 96.5753 27.408C94.0148 27.408 92.349 25.7973 92.349 23.5947C92.349 21.3783 94.0423 19.7814 96.3 19.7814C98.4751 19.7814 100.155 21.2406 100.155 23.6222ZM96.3138 21.4058C95.3363 21.4058 94.6343 21.9978 94.4828 22.9477H98.1309C97.9795 22.0116 97.2774 21.4058 96.3138 21.4058ZM103.333 21.6399H105.962V22.7962H101.158V21.8739L103.539 19.8089C104.09 19.3409 104.214 19.0793 104.214 18.8178C104.214 18.4598 103.911 18.1707 103.223 18.1707C102.658 18.1707 102.204 18.391 101.942 18.7627L100.841 18.1019C101.281 17.4274 102.121 16.9731 103.346 16.9731C104.847 16.9731 105.742 17.6889 105.742 18.7076C105.742 19.2583 105.549 19.7126 104.654 20.4835L103.333 21.6399Z" fill="#D80621"/>
                    </svg>
                <IconButton onClick={()=>{setIsDrower(false)}} sx={{position:"absolute",right:"0",top:"0"}}>
                    <CloseIcon sx={{color:"black",fontSize:"1.5rem"}}/>
                    
                </IconButton>
                </Title>

                <ListSectionCollapse>
                    {/* <Item_list lang={lang} isScroll={isScroll}  isSmall={isSmall} /> */}
                    {data_list.map((e,i)=>{
                        return<ItemListSection className={isScroll?"scroll":""} key={`${e.name}_sidebar_${i+300}`} onClick={()=>{
                            setIsDrower(false)
                        }}  >
                            <span>{e.icon}</span>
                            <LinkPages  to={e.href}>{e.name}</LinkPages>
                            </ItemListSection>
                    })}
                </ListSectionCollapse>
            
            </DivDrower>
          </Drawer>
         
            
    </>
}



function SubNav({isScroll,isSmall,lang,...props}) {
    const navigate= useNavigate()
    const [viewModal, setViewModal] = useState(false)
    const [isHover, setisHover] = React.useState(false)
    const isSoSmall = useBreakpoint(401)
    const Countainer = styled.div`
    width:100%;
    height:70px;
    display:flex;
    background:${props => props.theme.colors.main.default};
    padding:${props=>(isScroll?`0px 50px`:`0px 55px`)};
    box-shadow: 1px 4px 3px -1px #c5c5c5;
    color:white;
    @media(max-width:350px){
        padding:0px;
    }
    @media(min-width:350px) and (max-width:992px){
        padding:0px 15px;
    }
    @media(min-width:993px) and (max-width:1200px){
        padding:0px 10px;
    }

`
const ItemListSectionN = styled.li`
    color: ${props => (isScroll?"black":"white") };
    position: relative;
    cursor:pointer;
    display:flex;
    justify-content:space-between;
    align-items:center;
    height:100%;
    font-size:${props => props.theme.typography.Montserrat_Bold_xl.fontSize};
    font-weight:${props => props.theme.typography.Montserrat_Bold_xl.weight};
    font-family:${props => props.theme.typography.Montserrat_Bold_xl.fontFamily};
    line-height:${props => props.theme.typography.Montserrat_Bold_xl.lineHeight};

    @media (max-width:992px){
        display:none;
    };
  
`

const CustomButton = styled.button`
   margin-right: 15px;
    display: flex;  
    padding:10px;
    position: relative;
    padding: 5px 18px 5px 10px;
    justify-content: center;
    align-items: center;
    gap: 5px; 
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    cursor:pointer;
    border-radius:8px;
    border:none;
    height:45px;
    transition :0.2s;
    color:${props=> (isScroll?"white":"black")};
    background:${props=> (isScroll?`${props.theme.colors.main.default}`:"#fff")} ;
    border:${props => (isScroll?`2px solid  ${props.theme.colors.main.default}`:"2px solid white")};
    // box-shadow:${props => (isScroll?`2px 2px 2px #a8a0a1`:" ")};
    font-size:${props => props.theme.typography.Montserrat_SemiBold_sm.fontSize};
    font-weight:${props => props.theme.typography.Montserrat_SemiBold_sm.weight};
    font-family:${props => props.theme.typography.Montserrat_SemiBold_sm.fontFamily};
    line-height:${props => props.theme.typography.Montserrat_SemiBold_sm.lineHeight};
    &:hover {
        background-color: ${props=>(isScroll?`inherit`:`${props.theme.colors.main.default}`)};
        border:${props => (isScroll?`2px solid  ${props.theme.colors.main.default}`:"2px solid white")};
        color:${props=> (isScroll?"black":"white")}
        
      };
    @media (max-width:768px){
        // width:149px;
        height:39.19px;
        font-size:10px;
    }
    & .path_icon{
        fill:${props=>(isScroll?`white`:`${props.theme.colors.main.default}`)}; 
    }
    & .stroke_icon{
        stroke:${props=>(isScroll?`white`:`${props.theme.colors.main.default}`)}; 
    }
    &:hover {
      .path_icon{
            fill:${props=> (isScroll?`${props.theme.colors.main.default}`:"white")}; 
        }
      .stroke_icon{
            stroke:${props=> (isScroll?`${props.theme.colors.main.default}`:"white")}; 
        }
    }
    @media(min-width:993px) and (max-width:1200px){
        font-size:12px;  
        }
        
`
const CustomButton2 = styled.button`
   margin-right: 15px;
    display: none;  
    padding:10px;
    position: relative;
    padding: 5px 18px 5px 10px;
    justify-content: center;
    align-items: center;
    gap: 5px; 
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    cursor:pointer;
    border-radius:8px;
    border:none;
    height:45px;
    transition :0.2s;
    color:${props=> (isScroll?"white":"black")};
    background:${props=> (isScroll?`${props.theme.colors.main.default}`:"#fff")} ;
    border:${props => (isScroll?`2px solid  ${props.theme.colors.main.default}`:"2px solid white")};
    // box-shadow:${props => (isScroll?`2px 2px 2px #a8a0a1`:" ")};
    font-size:${props => props.theme.typography.Montserrat_SemiBold_sm.fontSize};
    font-weight:${props => props.theme.typography.Montserrat_SemiBold_sm.weight};
    font-family:${props => props.theme.typography.Montserrat_SemiBold_sm.fontFamily};
    line-height:${props => props.theme.typography.Montserrat_SemiBold_sm.lineHeight};
    &:hover {
        background-color: ${props=>(isScroll?`inherit`:`${props.theme.colors.main.default}`)};
        border:${props => (isScroll?`2px solid  ${props.theme.colors.main.default}`:"2px solid white")};
        color:${props=> (isScroll?"black":"white")}
        
      };
    @media (max-width:768px){
        // width:149px;
        height:39.19px;
        font-size:10px;
    }
    & .path_icon{
        fill:${props=>(isScroll?`white`:`${props.theme.colors.main.default}`)}; 
    }
    & .stroke_icon{
        stroke:${props=>(isScroll?`white`:`${props.theme.colors.main.default}`)}; 
    }
    &:hover {
      .path_icon{
            fill:${props=> (isScroll?`${props.theme.colors.main.default}`:"white")}; 
        }
      .stroke_icon{
            stroke:${props=> (isScroll?`${props.theme.colors.main.default}`:"white")}; 
        }
    }
    @media(min-width:993px) and (max-width:1200px){
        font-size:12px;  
        }
        @media (max-width: 500px) {
            display: flex;
        }
`
//new Styles for NavLink
const LinkPages=styled(NavLink)`
    color:unset;
    background:unset;

`
const ItemListSection = styled.li`
    color: ${props => (isScroll ?"black":"white") };
    position: relative;
    cursor:pointer;
    display:flex;
    justify-content:space-between;
    align-items:center;
    height:100%;
    background:${props=> isScroll?"unset":props.theme.colors.main.default};
    font-size:16px;
    font-weight:600;
    font-family:${props => props.theme.typography.Montserrat_Bold_xl.fontFamily};
    line-height:${props => props.theme.typography.Montserrat_Bold_xl.lineHeight};
    ${LinkPages}.active{
        font-weight:900;
    }
    
    ${LinkPages}.active:after{
        content:"";
        position:absolute;
        height:3px;
        background:${props=> isScroll?"black":"white"};
        top:50px;
        width:30px;
        left:${props=> isScroll?"5px":"0"};
        border-radius:4px;
        transition: all 0.3s ease-in-out;
    }
    &:after{
        content:"";
        position:absolute;
        height:3px;
        background:${props=> isScroll?"black":"white"};
        bottom:17px;
        width:0px;
        left:${props=> isScroll?"5px":"0"};
        border-radius:4px;
        transition: all 0.3s ease-in-out;
    }
    &:hover::after{
        width:30px;

    }
    @media(max-width:992px){
        font-size:12px;  
      }
    @media(min-width:993px) and (max-width:1200px){
    font-size:12px;  
    }
    @media(min-width:1201px) and (max-width:1400px){
      font-size:14px;  
    }
    @media (max-width:900px){
        display:none;
    };
  
`


const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const nav = ()=>{
    window.location.href = 'http://mobile.winshakes.com';
  }
    React.useEffect(()=>{
      
    },[])
    const data_list =  localStorage.hasOwnProperty("user")?nav_with_user_login:nav_without_user_login
    return (<Countainer  {...props}>
        <Item_list lang={lang} isScroll={isScroll}  isSmall={isSmall} />
        <ListSection>
            
            {data_list.map((e,i)=>{
                return<ItemListSection  key={`${e.name}_list_${i+10}`} >
                   
                    <LinkPages to={e.href}>{e.name}</LinkPages>
                     </ItemListSection>
            })}
        </ListSection>

        <ButtonSection>
        <CustomButton2  
         onClick={()=>{  nav()  }}>
        <svg width="80" height="25" viewBox="0 0 33 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.5602 4.24834C17.6081 4.24834 15.312 4.90436 14 8.18447C15.9681 6.54442 17.9361 6.21641 20.5602 6.87243V8.8405L24.4964 5.56039L20.5602 2.28027V4.24834Z" fill="#D80621"/>
        <path d="M31.7496 10.1799C31.7496 10.1799 32.5829 10.1799 32.5829 9.34543V1.8345C32.5829 1 31.7496 1 31.7496 1H28.8333C28.8333 1 28 1 28 1.8345V9.34543C28 10.1799 28.8333 10.1799 28.8333 10.1799H31.7496ZM30.2914 9.83246C30.0615 9.83246 29.8748 9.6458 29.8748 9.41584C29.8748 9.18586 30.0615 8.99922 30.2914 8.99922C30.5214 8.99922 30.7081 9.18587 30.7081 9.41584C30.7081 9.64581 30.5214 9.83246 30.2914 9.83246ZM29.6665 1.5087C29.6665 1.45704 29.6911 1.41662 29.7219 1.41662H30.861C30.8914 1.41662 30.9164 1.45787 30.9164 1.5087V1.53328C30.9164 1.58494 30.8914 1.62536 30.861 1.62536H29.7219C29.6915 1.62536 29.6665 1.58411 29.6665 1.53328V1.5087ZM28.4166 2.04156H32.1663V8.70757H28.4166V2.04156Z" fill="#D80621"/>
        <path d="M10.3409 7.1062C10.0161 7.95738 9.44041 8.68983 8.6901 9.20659C7.93979 9.72335 7.05023 10.0001 6.13919 10.0001C5.22815 10.0001 4.33859 9.72335 3.58828 9.20659C2.83797 8.68983 2.26231 7.95738 1.9375 7.1062" stroke="#D80621" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1.9375 3.89385C2.26231 3.04267 2.83797 2.31022 3.58828 1.79346C4.33859 1.2767 5.22815 1 6.13919 1C7.05023 1 7.93979 1.2767 8.6901 1.79346C9.44041 2.31022 10.0161 3.04267 10.3409 3.89385" stroke="#D80621" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1.9375 7.1062H10.3409" stroke="#D80621" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1 4.85742L1.64246 6.14234L2.28492 4.85742L2.92738 6.14234L3.56984 4.85742" stroke="#D80621" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.85547 4.85742L5.49793 6.14234L6.14039 4.85742L6.78285 6.14234L7.42531 4.85742" stroke="#D80621" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8.70898 4.85742L9.35144 6.14234L9.9939 4.85742L10.6364 6.14234L11.2788 4.85742" stroke="#D80621" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.86099 3.89376C7.57895 2.78374 6.98083 1.77944 6.1392 1.00269C5.30223 1.77434 4.70647 2.77173 4.42383 3.87448" stroke="#D80621" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.41797 7.1062C4.70001 8.21622 5.29813 9.22052 6.13976 9.99727C6.98139 9.22052 7.57951 8.21622 7.86156 7.1062" stroke="#D80621" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1.9375 3.8938H10.3409" stroke="#D80621" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
                {/* </Icon> */}

                Mobile App
            </CustomButton2>
            
            <CustomButton  onClick={()=>{
                if(localStorage.getItem("user")){
                    navigate("/shakes")
                }else{
                    if(window.location.origin + window.location.pathname !=`${window.location.origin}/autherization` && window.location.origin + window.location.pathname !=`${window.location.origin}/register`){
                        setViewModal(true)
                    }  
                }   
            }}   >
             {/* <Icon> */}
                {/* <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                
                <PathFill d="M28.4093 10.0597L24.1737 11.1946C24.2101 11.1421 24.2481 11.0906 24.2827 11.036C24.5621 10.612 24.751 10.1348 24.8376 9.63446C24.9241 9.13407 24.9066 8.6212 24.7859 8.12793C24.658 7.5872 24.4209 7.07831 24.0893 6.63251C23.7576 6.18671 23.3383 5.8134 22.8571 5.5355C22.376 5.2576 21.8431 5.08098 21.2912 5.01648C20.7393 4.95198 20.18 5.00096 19.6478 5.16041C19.16 5.30243 18.7068 5.54362 18.3165 5.86886C17.9262 6.1941 17.6073 6.59641 17.3797 7.05059C17.0687 7.69411 16.8602 8.38222 16.7615 9.09008C16.3221 8.5264 15.7974 8.03477 15.2063 7.63293C14.7821 7.35341 14.3048 7.16447 13.8042 7.07794C13.3036 6.9914 12.7905 7.00913 12.2971 7.13002C11.7564 7.25807 11.2475 7.49528 10.8018 7.82709C10.3561 8.1589 9.98295 8.5783 9.7052 9.05955C9.42745 9.5408 9.25098 10.0737 9.18665 10.6257C9.12231 11.1776 9.17146 11.7368 9.33107 12.269C9.4732 12.7566 9.7144 13.2095 10.0396 13.5996C10.3648 13.9896 10.7669 14.3084 11.2209 14.5359C11.2775 14.5634 11.3361 14.5891 11.3945 14.6188L7.15895 15.7537C6.64659 15.891 6.20976 16.2262 5.94454 16.6856C5.67932 17.1449 5.60745 17.6908 5.74474 18.2032L6.78002 22.0669C6.9173 22.5793 7.2525 23.0161 7.71187 23.2813C8.17124 23.5465 8.71715 23.6184 9.22951 23.4811L11.3001 31.2085C11.4373 31.7209 11.7725 32.1577 12.2319 32.4229C12.6913 32.6881 13.2372 32.76 13.7495 32.6227L31.1362 27.964C31.6486 27.8267 32.0854 27.4915 32.3506 27.0321C32.6158 26.5728 32.6877 26.0269 32.5504 25.5145L30.4799 17.7871C30.9922 17.6498 31.4291 17.3146 31.6943 16.8552C31.9595 16.3959 32.0314 15.85 31.8941 15.3376L30.8588 11.4739C30.7215 10.9615 30.3863 10.5247 29.927 10.2595C29.4676 9.99427 28.9217 9.9224 28.4093 10.0597ZM19.1715 7.94221C19.2792 7.73234 19.4291 7.547 19.6118 7.39782C19.7946 7.24864 20.0062 7.13886 20.2333 7.07535L20.2925 7.0595C20.56 6.98962 20.8387 6.97382 21.1124 7.01305C21.3861 7.05228 21.6491 7.14573 21.8862 7.28794C22.1233 7.43014 22.3296 7.61824 22.4931 7.8412C22.6566 8.06417 22.7739 8.31752 22.8382 8.58641C22.8968 8.8149 22.9075 9.05304 22.8697 9.28587C22.8318 9.51871 22.7463 9.74121 22.6184 9.9394C21.7443 11.2606 19.9384 12.1276 18.7936 12.5689C18.5959 11.2515 18.4964 9.28649 19.1715 7.94221ZM11.4449 10.0591C11.7188 9.58468 12.169 9.23756 12.6976 9.09326L12.7567 9.0774C12.9852 9.01881 13.2234 9.00809 13.4562 9.04592C13.689 9.08375 13.9115 9.1693 14.1097 9.29721C15.4294 10.1704 16.2954 11.9727 16.7355 13.1126C15.5295 13.3064 13.5344 13.4527 12.1183 12.7464C11.9085 12.6387 11.7231 12.4888 11.574 12.3061C11.4248 12.1234 11.315 11.9118 11.2515 11.6846C11.1713 11.4152 11.1466 11.1323 11.1791 10.8532C11.2115 10.574 11.3003 10.3043 11.4401 10.0604L11.4449 10.0591ZM7.67659 17.6856L17.3358 15.0974L18.3711 18.9611L8.71187 21.5493L7.67659 17.6856ZM11.1614 22.9635L18.8888 20.8929L20.9593 28.6203L13.2319 30.6909L11.1614 22.9635ZM30.6186 26.0321L22.8912 28.1027L20.8206 20.3753L28.548 18.3047L30.6186 26.0321ZM29.9622 15.8552L20.303 18.4434L19.2677 14.5797L28.927 11.9915L29.9622 15.8552Z"  />
                <Path d="M27.3673 7.55393L28.1171 7.30399C30.6987 6.44346 33.4768 7.90881 34.2244 10.5254V10.5254" />
                <Path d="M26.453 6.09952L27.5139 5.74591C31.1664 4.52841 35.0969 6.60161 36.1546 10.3035V10.3035" />
                </svg>  */}
               <svg xmlns="http://www.w3.org/2000/svg" width={isSoSmall?"30":"40"} height={isSoSmall?"30":"40"} viewBox="0 0 86 86" fill="none">
                    <path className='path_icon' d="M62.1455 21.9799L52.8801 24.4625C52.9598 24.3477 53.0428 24.2349 53.1184 24.1156C53.7296 23.188 54.1428 22.1443 54.3322 21.0497C54.5216 19.9551 54.4832 18.8332 54.2192 17.7541C53.9394 16.5713 53.4209 15.4581 52.6953 14.4829C51.9698 13.5077 51.0526 12.6911 50 12.0832C48.9475 11.4753 47.7818 11.0889 46.5745 10.9478C45.3673 10.8068 44.1439 10.9139 42.9795 11.2627C41.9125 11.5734 40.9212 12.101 40.0674 12.8124C39.2137 13.5239 38.5161 14.4039 38.0181 15.3975C37.338 16.8052 36.8817 18.3104 36.6658 19.8589C35.7046 18.6258 34.5569 17.5503 33.264 16.6713C32.336 16.0599 31.2918 15.6466 30.1967 15.4573C29.1016 15.268 27.9793 15.3068 26.8999 15.5712C25.7171 15.8513 24.6041 16.3702 23.6291 17.0961C22.6541 17.8219 21.8378 18.7393 21.2302 19.7921C20.6226 20.8448 20.2366 22.0106 20.0959 23.2179C19.9551 24.4252 20.0626 25.6486 20.4118 26.8128C20.7227 27.8793 21.2503 28.8701 21.9617 29.7233C22.673 30.5766 23.5527 31.2739 24.5458 31.7716C24.6696 31.8318 24.7979 31.888 24.9256 31.9529L15.6603 34.4355C14.5395 34.7358 13.5839 35.4691 13.0038 36.474C12.4236 37.4788 12.2664 38.673 12.5667 39.7938L14.8314 48.2456C15.1317 49.3664 15.8649 50.322 16.8698 50.9022C17.8747 51.4823 19.0688 51.6395 20.1896 51.3392L24.719 68.2429C25.0193 69.3637 25.7525 70.3193 26.7574 70.8995C27.7623 71.4796 28.9564 71.6368 30.0772 71.3365L68.1105 61.1455C69.2313 60.8452 70.1869 60.112 70.7671 59.1071C71.3472 58.1022 71.5045 56.9081 71.2041 55.7873L66.6748 38.8836C67.7956 38.5833 68.7512 37.85 69.3313 36.8451C69.9115 35.8403 70.0687 34.6461 69.7684 33.5253L67.5037 25.0735C67.2034 23.9527 66.4702 22.9971 65.4653 22.4169C64.4604 21.8368 63.2663 21.6796 62.1455 21.9799ZM41.9378 17.3479C42.1733 16.8888 42.5013 16.4833 42.901 16.157C43.3007 15.8307 43.7635 15.5905 44.2605 15.4516L44.3899 15.417C44.975 15.2641 45.5848 15.2295 46.1834 15.3153C46.7821 15.4011 47.3576 15.6056 47.8762 15.9167C48.3949 16.2277 48.8462 16.6392 49.2038 17.1269C49.5613 17.6147 49.818 18.1689 49.9586 18.7571C50.0868 19.2569 50.1102 19.7778 50.0275 20.2871C49.9447 20.7965 49.7576 21.2832 49.4778 21.7167C47.5657 24.607 43.6153 26.5034 41.1111 27.4688C40.6786 24.5868 40.461 20.2885 41.9378 17.3479ZM25.0358 21.9787C25.6351 20.9408 26.6199 20.1815 27.776 19.8658L27.9055 19.8311C28.4053 19.703 28.9262 19.6795 29.4355 19.7622C29.9449 19.845 30.4316 20.0321 30.8651 20.312C33.752 22.222 35.6463 26.1645 36.6089 28.6582C33.9709 29.082 29.6066 29.4021 26.509 27.857C26.0499 27.6215 25.6444 27.2936 25.3181 26.8938C24.9918 26.4941 24.7516 26.0313 24.6127 25.5343C24.4373 24.9451 24.3834 24.3263 24.4543 23.7156C24.5252 23.1048 24.7194 22.5149 25.0252 21.9815L25.0358 21.9787ZM16.7926 38.6615L37.9223 32.9998L40.1869 41.4516L19.0573 47.1133L16.7926 38.6615ZM24.4156 50.2069L41.3193 45.6776L45.8486 62.5813L28.9449 67.1106L24.4156 50.2069ZM66.9782 56.9196L50.0745 61.4489L45.5452 44.5452L62.4489 40.0159L66.9782 56.9196ZM65.5425 34.6576L44.4128 40.3193L42.1482 31.8675L63.2778 26.2058L65.5425 34.6576Z" />
                    <path className='stroke_icon' d="M59.866 16.5L61.5062 15.9533C67.1535 14.0708 73.2306 17.2763 74.866 23V23" />
                    <path className='stroke_icon' d="M57.8661 13.3185L60.1867 12.545C68.1765 9.88168 76.7745 14.4168 79.0883 22.5148V22.5148"/>
                </svg>
                {/* </Icon> */}

                Shake and Win
            </CustomButton>
            
        </ButtonSection>
        <Modal 
                    open={viewModal }
                    onClose={()=>{setViewModal(false)}}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={{
                        position: 'absolute' ,
                        top: '50%',
                        left: '50%',
                        borderRadius:"8px",
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        // border: '2px solid #000',
                        boxShadow: 24,
                        p: 4,
                        "@media(max-width:300px)":{
                            width:"280px",
                            padding:"10px 5px !important"
                        },
                        "@media(min-width:301px) and (max-width:400px)":{
                            width:"350px",
                            padding:"10px 5px !important"
                        },
                        "@media(min-width:401px) and (max-width:600px) ":{
                            width:"400px"
                        },
                        "@media(min-width:601px)":{
                            width:"550px"
                        },
                }}>
                        <Box sx={{position:"relative",height:"50px"}}>
                            <IconButton onClick={()=>{setViewModal(false)}} sx={{color:"black",position:"absolute",right:"0px",top:"0px"}}>
                                <Close/>
                            </IconButton>
                        </Box>
                        <Box sx={{display:"flex",justifyContent:"center"}}>
                            <img style={{width:"300px",height:"200px",objectFit:"contain"}} alt="box" src={golden_box} />
                        </Box>
                        <Box sx={{textAlign :"center",marginBottom:"10px"}}>
                            <h6 style={{color:"black",fontSize:"18px"}}>
                               To win with us login or register
                            </h6>
                           

                        </Box>
                        <Grid  container>
                            <Grid item sx={{display:"flex",justifyContent:"center",padding:"10px 0"}} lg={6} md={6} sm={12} xs={12} xl={6}>
                            <Button onClick={()=>{
                                navigate("/register",{state:{continue_url:"/shakes"}})
                                setViewModal(false)}} sx={{
                                width:'70%',
                                background:"white",
                                borderRadius:"4px",
                                border:"1px solid #d80621",
                                color:" #d80621",
                                transition:"0.5s",
                                textTransform:"capitalize !important",
                                fontSize:"16px !important",
                                padding:"5px 40px ",
                                "&:hover":{
                                    background:"#d80621",
                                    border:"1px solid white ",
                                    color:"white"
                                }
                            }}
                            >Register</Button>
                            </Grid>
                            <Grid item sx={{display:"flex",justifyContent:"center",padding:"10px 0"}} lg={6} md={6} sm={12} xs={12} xl={6}>
                            <Button onClick={()=>{
                                navigate("/autherization",{state:{continue_url:"/shakes"}})
                                setViewModal(false)
                                }} sx={{  width:'80%',
                                            background:"#d80621",
                                            borderRadius:"4px",
                                            border:"1px solid  #d80621",
                                            color:"white",
                                            transition:"0.5s",
                                            textTransform:"capitalize !important",
                                            fontSize:"16px !important",
                                            padding:"5px 40px",
                                            "&:hover":{
                                                background:"white",
                                                border:"1px solid  #d80621",
                                                color:"#d80621"
                                            }
                                        }}
                                >Login
                                
                                </Button>
                            </Grid>
                        </Grid>
                            
                    </Box>
                </Modal>
    </Countainer> 
    );
}
const mapStateToProps = (state)=>{
    return{
        lang :state.lang
    }
}
export default connect(mapStateToProps,null)(SubNav);